import api from '@/lib/api';
import { API_ENDPOINTS } from '@/constants/endpoints';
import type { ApiResponse } from '@/types';
import type { CurrentUser } from '@/stores/auth.store';

interface LoginResponse {
  token: string;
  refreshToken: string;
  user: CurrentUser;
}

export const authService = {
  async login(email: string, password: string): Promise<LoginResponse> {
    const res = await api.post<ApiResponse<LoginResponse>>(
      API_ENDPOINTS.AUTH.LOGIN,
      { email, password },
      { authRequired: false }
    );
    return res.data.data;
  }
};
